export const UPLOAD_ZONE_RATE_SUCCESS = 'UPLOAD_ZONE_RATE_SUCCESS';
export const UPLOAD_ZONE_RATE_REQUEST = 'UPLOAD_ZONE_RATE_REQUEST';
export const UPLOAD_ZONE_RATE_FAILURE = 'UPLOAD_ZONE_RATE_FAILURE';
export const UPLOAD_ZONE_RATE_REST = 'UPLOAD_ZONE_RATE_REST';
export const uploadZoneRateSuccess = (payload) => ({
    type: UPLOAD_ZONE_RATE_SUCCESS,
    payload,
});
export const uploadZoneRateRequest = (payload) => ({
    type: UPLOAD_ZONE_RATE_REQUEST,
    payload,
});
export const uploadZoneRateFailure = (payload) => ({
    type: UPLOAD_ZONE_RATE_FAILURE,
    payload,
});
export const uploadZoneRateRest = () => ({
    type: UPLOAD_ZONE_RATE_REST,
});
